import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDownIcon, FlagIcon, HeartHandshakeIcon, MailIcon, ShieldIcon } from 'lucide-react';
import { BrandMark } from '../../components/BrandMark';
import { PageHeader } from '../../components/PageHeader';
import { SettingsGroup, SettingsRow } from '../../components/SettingsList';
import { Card, SectionTitle } from '../../components/ui/Card';
import { APP_VERSION, faq } from '../../data/settings';
import { useLocale } from '../../contexts/LocaleContext';
export function HelpSupport() {
  const {
    t,
    tl
  } = useLocale();
  const navigate = useNavigate();
  const [open, setOpen] = useState<string | null>(faq[0].id);
  return <div className="px-2 pb-2" data-id="element-3844" data-mp="2ygapkphtpzy4">
      <PageHeader title={t('settings.help')} subtitle={t('help.subtitle')} showBack data-id="element-3845" data-mp="2yezq31vevect" />

      <SectionTitle data-id="element-3846" data-mp="2apotlwl3g64h">{t('help.faq')}</SectionTitle>
      <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-3847" data-mp="25rwqs7iwuzli">
        {faq.map(entry => {
        const expanded = open === entry.id;
        return <li key={entry.id} className="border-b border-sand-line last:border-b-0" data-id="element-3848" data-mp="3ru3x28f1d0m5">
              <button type="button" aria-expanded={expanded} onClick={() => setOpen(expanded ? null : entry.id)} className="flex min-h-[52px] w-full items-center gap-2 py-2 text-left" data-id="element-3849" data-mp="3vvyw169hv1wr">
                <span className="min-w-0 flex-1 text-[13.5px] font-medium text-deep" data-id="element-3850" data-mp="38y42qqyl5kze">
                  {tl(entry.question)}
                </span>
                <ChevronDownIcon size={16} className={`shrink-0 text-muted transition-transform duration-150 ease-brand ${expanded ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-3851" data-mp="3d10epytmeiud" />
              </button>
              {expanded && <p className="pb-2 text-[12.5px] leading-relaxed text-muted" data-id="element-3852" data-mp="126cxz75679ge">
                  {tl(entry.answer)}
                </p>}
            </li>;
      })}
      </ul>

      <div className="mt-3" data-id="element-3853" data-mp="7k5p8vvw6ddf">
        <SectionTitle data-id="element-3854" data-mp="7iunt2px5hph">{t('help.contactGroup')}</SectionTitle>
        <SettingsGroup data-id="element-3855" data-mp="mgmzfjschlye">
          <SettingsRow label={t('help.contact')} hint="suporte@beelyv.com" icon={<MailIcon size={17} data-id="element-3857" data-mp="hiv6qnjvlvt5" />} data-id="element-3856" data-mp="mfvf55477anf" />
          <SettingsRow label={t('help.report')} hint={t('help.reportHint')} icon={<FlagIcon size={17} data-id="element-3859" data-mp="3kyk9hk4ooqno" />} data-id="element-3858" data-mp="hfzdhciz3vb1" />
          <SettingsRow label={t('help.guidelines')} icon={<HeartHandshakeIcon size={17} data-id="element-3861" data-mp="3ikhtq24mram" />} data-id="element-3860" data-mp="3kzvaxdanpmbm" />
          <SettingsRow label={t('help.safety')} icon={<ShieldIcon size={17} data-id="element-3863" data-mp="3uw6o05i2mg74" />} data-id="element-3862" data-mp="3k5cdfofya8h" />
        </SettingsGroup>
      </div>

      <div className="mt-3" data-id="element-3864" data-mp="3uuvpak3hfymv">
        <SectionTitle data-id="element-3865" data-mp="376m85vh7rz22">{t('help.about')}</SectionTitle>
        <Card className="p-2" data-id="element-3866" data-mp="37518xsjyfrxv">
          <div className="flex items-center gap-2" data-id="element-3867" data-mp="328asv585gwcg">
            <BrandMark size={34} data-id="element-3868" data-mp="327spzpqzfjvk" />
            <div className="min-w-0 flex-1" data-id="element-3869" data-mp="1hq0edpxlnuh3">
              <p className="text-[13.5px] font-bold text-deep" data-id="element-3870" data-mp="1hp8i0cw6hspr">BEELYV</p>
              <p className="bee-num mt-[2px] text-[11.5px] text-muted" data-id="element-3871" data-mp="1mh8jwavt6voz">
                {t('help.version')} {APP_VERSION}
              </p>
            </div>
          </div>
          <p className="mt-2 text-[12.5px] leading-relaxed text-muted" data-id="element-3872" data-mp="1cqx67wmbp84w">
            {t('help.aboutBody')}
          </p>
        </Card>
      </div>

      <div className="mt-3" data-id="element-3873" data-mp="20hjbxh8uugbq">
        <SettingsGroup data-id="element-3874" data-mp="20hb443rla17e">
          <SettingsRow label={t('help.states')} hint={t('help.statesHint')} onClick={() => navigate('/estados')} data-id="element-3875" data-mp="25fkve3a70hnq" />
        </SettingsGroup>
      </div>
    </div>;
}